import apiClient from '../../lib/axios';

export const fetchIecMaterialFormats = async ({ page = 1, pageSize = 10, isActive, search } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  if (search) params.append('search', search);
  const { data } = await apiClient.get(`/api/iec-material-formats?${params.toString()}`);
  return data;
};

export const fetchActiveIecMaterialFormats = async () => {
  const { data } = await apiClient.get('/api/iec-material-formats/active');
  return data;
};

export const fetchIecMaterialFormatById = async (id) => {
  const { data } = await apiClient.get(`/api/iec-material-formats/${id}`);
  return data;
};

export const createIecMaterialFormat = async (payload) => {
  const { data } = await apiClient.post('/api/iec-material-formats', payload);
  return data;
};

export const updateIecMaterialFormat = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/iec-material-formats/${id}`, payload);
  return data;
};

export const deleteIecMaterialFormat = async (id) => {
  const { data } = await apiClient.delete(`/api/iec-material-formats/${id}`);
  return data;
};

export default fetchIecMaterialFormats;
